import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import GamesView from '../views/GamesView.vue'
import GameDetailView from '../views/GameDetailView.vue'
import AboutView from '../views/AboutView.vue'
import NewView from '../views/NewView.vue'
import PartnersView from '../views/PartnersView.vue'
import ContactsView from '../views/ContactsView.vue'
import AccountView from '../views/AccountView.vue'
import TermsView from '../views/TermsView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'games',
    component: GamesView
  },
  {
    path: '/game/:name',
    name: 'game-detail',
    component: GameDetailView,
    props: true
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/news',
    name: 'news',
    component: NewView
  },
  {
    path: '/partners',
    name: 'partners',
    component: PartnersView
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsView
  },
  {
    path: '/account',
    name: 'account',
    component: AccountView
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView
  }

  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  }
})

export default router
